import { AccessibilityState } from '../types/accessibility.types';

export const STORAGE_KEY = 'app_accessibility_settings';

export const DEFAULT_ACCESSIBILITY_STATE: AccessibilityState = {
  fontScale: 1,
  theme: 'light',
  underlineLinks: false,
  highlightLinks: false,
  readableFont: false,
  reduceMotion: false,
  textSpacing: false,
  largeCursor: false,
  readingGuide: false,
};

export const MIN_FONT_SCALE = 0.8;
export const MAX_FONT_SCALE = 1.5;
export const FONT_STEP = 0.1;